export const en = {
  // Navigation
  nav: {
    dashboard: "Dashboard",
    buildings: "Buildings",
    units: "Units",
    contracts: "Contracts",
    buyers: "Buyers",
    reports: "Reports",
    settings: "Settings",
  },
  
  // User Menu
  user: {
    profile: "Profile",
    appearance: "Appearance",
    light: "Light",
    dark: "Dark",
    system: "System",
    language: "Language",
    currency: "Currency",
    english: "English",
    serbian: "Srpski",
    bam: "BAM",
    eur: "EUR",
    usd: "USD",
    rsd: "RSD",
    logout: "Logout",
  },

  // Common
  common: {
    search: "Search",
    filter: "Filter",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    save: "Save",
    saveChanges: "Save Changes",
    back: "Back",
    next: "Next",
    continue: "Continue",
    view: "View",
    viewAll: "View all",
    viewDetails: "View Details",
    download: "Download",
    export: "Export",
    import: "Import",
    close: "Close",
    actions: "Actions",
    status: "Status",
    type: "Type",
    date: "Date",
    price: "Price",
    total: "Total",
    all: "All",
    none: "None",
    yes: "Yes",
    no: "No",
    loading: "Loading...",
    noResults: "No results found",
    enable: "Enable",
    change: "Change",
    rows: "rows",
    units: "units",
    notFound: "Not found",
    required: "Required",
    optional: "Optional",
    errorOccurred: "An error occurred.",
    notes: "Notes",
    address: "Address",
    name: "Name",
    email: "Email",
    phone: "Phone",
    id: "ID",
    location: "Location",
    method: "Method",
    reference: "Reference",
    amount: "Amount",
    remaining: "Remaining",
    complete: "complete",
    overdue: "Overdue",
    pending: "Pending",
    legend: "Legend",
    customerSince: "Customer Since",
    contactInfo: "Contact Information",
  },

  // Dashboard
  dashboard: {
    title: "Dashboard",
    description: "Welcome back. Here's an overview of your real estate portfolio.",
    totalBuildings: "Total Buildings",
    acrossLocations: "Across {count} locations",
    activeUnits: "Active Units",
    activeContracts: "Active Contracts",
    pendingSignature: "{count} pending signature",
    revenueCollected: "Revenue Collected",
    outstanding: "{amount} outstanding",
    fromLastMonth: "from last month",
    revenueCollection: "Revenue Collection",
    collected: "Collected",
    projected: "Projected",
    unitStatusOverview: "Unit Status Overview",
    totalUnits: "Total Units",
    recentPayments: "Recent Payments",
    pendingActions: "Pending Actions",
    viewAllActions: "View All Actions",
    pendingBuyerSignature: "Pending buyer signature",
    overduePayment: "Overdue payment",
    loadError: "Failed to load dashboard summary.",
    portfolioValue: "Portfolio Value",
    overdueAmount: "Overdue",
    availableValue: "Available Stock",
    salesCompletion: "Portfolio Sold",
    overdueAlert: "{count} overdue {count, plural, one {payment} other {payments}} · {amount} total",
    unsignedAlert: "{count} {count, plural, one {contract} other {contracts}} pending signature",
    buildingOverview: "Buildings Overview",
    upcomingPayments30: "Upcoming Payments · 30 days",
    noUpcoming: "No payments due in next 30 days",
    noOverdue: "All payments are on time",
    emptyTitle: "Welcome to Kvadrat",
    emptyDescription: "Your portfolio is empty. Start by adding your first building — once it's set up you can import units, create contracts, and track payments all in one place.",
    emptySubtext: "It only takes a minute to get started.",
    emptyAction: "Add your first building",
  },

  // Buildings
  buildings: {
    title: "Buildings",
    description: "Manage your building projects and track their progress.",
    addBuilding: "Add Building",
    addNewBuilding: "Add New Building",
    editBuilding: "Edit Building",
    viewUnits: "View Units",
    manageFloors: "Manage Floors",
    lamellas: "Lamellas",
    invested: "Invested",
    salesProgress: "Sales Progress",
    sold: "Sold",
    contracted: "Contracted",
    available: "available",
    statusPlanning: "Planning",
    statusConstruction: "Under Construction",
    statusSelling: "Selling",
    statusCompleted: "Completed",
    backToBuildings: "Back to Buildings",
    backToBuilding: "Back to Building",
    floorGrid: "Floor Grid",
    totalValue: "Total Value",
    notFound: "Building not found.",
    loadError: "Failed to load buildings.",
    loadOneError: "Failed to load building.",
    deleteConfirm: "Delete building \"{name}\"? This cannot be undone. All lamellas must be removed first.",
    deleteLamellaConfirm: "Delete lamella {name}? All units in this lamella must be removed first.",
  },

  // Units
  units: {
    title: "Units",
    description: "{count} units across {lamellas} lamellas",
    addUnit: "Add Unit",
    editUnit: "Edit Unit",
    createContract: "Create Contract",
    searchPlaceholder: "Search by unit ID or title...",
    totalUnits: "Total Units",
    available: "Available",
    contracted: "Contracted",
    sold: "Sold",
    totalValue: "Total Value",
    soldValue: "Sold Value",
    allLamellas: "All Lamellas",
    lamella: "Lamella",
    allTypes: "All Types",
    apartments: "Apartments",
    parking: "Parking",
    storage: "Storage",
    commercial: "Commercial",
    allStatus: "All Status",
    unit: "Unit",
    floor: "Floor",
    area: "Area",
    noUnitsMatch: "No units match your filters.",
    backToUnits: "Back to Units",
    unitDetails: "Unit Details",
    pricePerSqm: "Price per m²",
    noContractLinked: "No contract linked",
    notFound: "Unit not found.",
    loadError: "Failed to load unit.",
    deleteConfirm: "Delete unit {number}? Only available units can be deleted.",
  },

  // Contracts
  contracts: {
    title: "Contracts",
    description: "Manage buyer contracts and track payment progress.",
    newContract: "New Contract",
    editContract: "Edit Contract",
    addPayment: "Add Payment",
    downloadPdf: "Download PDF",
    searchPlaceholder: "Search by contract number, buyer, or unit...",
    totalContracts: "Total Contracts",
    signed: "Signed",
    collected: "Collected",
    outstanding: "Outstanding",
    allContracts: "All Contracts",
    pendingSignature: "Pending Signature",
    fullyPaid: "Fully Paid",
    partiallyPaid: "Partially Paid",
    unpaid: "Unpaid",
    contract: "Contract",
    buyers: "Buyers",
    paymentProgress: "Payment Progress",
    pending: "Pending",
    paid: "Paid",
    partial: "Partial",
    noContractsMatch: "No contracts match your filters.",
    unknown: "Unknown",
    backToContracts: "Back to Contracts",
    contractInfo: "Contract Info",
    contractDate: "Contract Date",
    signedDate: "Signed Date",
    paymentType: "Payment Type",
    paymentSchedule: "Payment Schedule",
    paymentHistory: "Payment History",
    recordPayment: "Record Payment",
    dueDate: "Due Date",
    paidDate: "Paid Date",
    paidOf: "paid of",
    contractNumber: "Contract #",
    noContractsYet: "No contracts yet",
    notFound: "Contract not found.",
    loadError: "Failed to load contracts.",
    loadOneError: "Failed to load contract.",
    deleteConfirm: "Delete contract #{number}? Only contracts with no payments can be deleted.",
    wizardDescription: "Guided contract creation: buyer, units, totals, and confirmation.",
    wizardStepOf: "Step {current} of {total}",
    wizardStepBuyer: "Buyer",
    wizardStepUnits: "Units",
    wizardStepTotalsPayment: "Totals & Payment",
    wizardStepConfirmation: "Confirmation",
    wizardSelectPaymentMethod: "Please select at least one payment method.",
    wizardRequiredBuyerFields: "Please fill all required buyer fields.",
    wizardReviewTitle: "Review Selection",
    wizardFileUploadTitle: "Contract File Upload",
    wizardUploadHint: "Upload signed paper contract (optional)",
    wizardNoFile: "No file selected.",
    generateSchedule: "Generate Payment Schedule",
    numberOfInstallments: "Number of Installments",
    generate: "Generate",
    addInstallment: "Add Installment",
    scheduleTotal: "Schedule Total",
    scheduleVsRemaining: "vs remaining",
    saveSchedule: "Save Schedule",
    scheduleCreated: "Schedule Created",
    scheduleCreatedDesc: "{count} installments saved.",
    markAsPaid: "Mark as Paid",
    markAsUnpaid: "Mark as Unpaid",
    generateScheduleButton: "Generate Schedule",
  },

  // Buyers
  buyers: {
    title: "Buyers",
    description: "Manage buyer profiles and track their contracts.",
    addBuyer: "Add Buyer",
    editBuyer: "Edit Buyer",
    viewProfile: "View Profile",
    viewContracts: "View Contracts",
    logCommunication: "Log Communication",
    searchPlaceholder: "Search by name, email, or phone...",
    totalBuyers: "Total Buyers",
    totalContracts: "Total Contracts",
    totalPaid: "Total Paid",
    outstanding: "Outstanding",
    buyer: "Buyer",
    contact: "Contact",
    balance: "Balance",
    paidInFull: "Paid in Full",
    noBuyersMatch: "No buyers match your search.",
    contract: "contract",
    contracts: "contracts",
    paid: "Paid",
    backToBuyers: "Back to Buyers",
    buyerNotFound: "Buyer not found.",
    loadError: "Failed to load buyers.",
    loadOneError: "Failed to load buyer.",
    deleteConfirm: "Delete buyer \"{name}\"? Only buyers without contracts can be deleted.",
  },

  // Not Found page
  notFound: {
    description: "Oops! Page not found",
    returnHome: "Return to Home",
  },

  // Reports
  reports: {
    title: "Reports",
    description: "Generate and export operational and financial reports.",
    operationalReports: "Operational Reports",
    financialReports: "Financial Reports",
    unitStatusReport: "Unit Status Report",
    unitStatusDesc: "Available, Contracted, and Sold breakdown by building",
    contractSummary: "Contract Summary",
    contractSummaryDesc: "All contracts with status and remaining balances",
    buyerReport: "Buyer Report",
    buyerReportDesc: "All buyers with their contracts and payment history",
    cashFlowAnalysis: "Cash Flow Analysis",
    cashFlowDesc: "Payments received by period with trends",
    outstandingBalances: "Outstanding Balances",
    outstandingDesc: "Aging report of unpaid amounts",
    projectPL: "Project P&L",
    projectPLDesc: "Investment vs sales by building",
    upcomingPayments: "Upcoming Payments",
    upcomingPaymentsDesc: "Scheduled payments due in the next 30 / 60 / 90 days",
    salesVelocity: "Sales Velocity",
    salesVelocityDesc: "Number of units contracted per month",
    contractsWithoutPlan: "Contracts Without Payment Plan",
    contractsWithoutPlanDesc: "Active contracts with no scheduled payments and no payments recorded",
    daysUntilDue: "Days Until Due",
    unitsContracted: "Units Contracted",
    noPlan: "No Plan",
  },

  // Settings
  settings: {
    title: "Settings",
    description: "Manage your account and application preferences.",
    profile: "Profile",
    fullName: "Full Name",
    email: "Email",
    companyName: "Company Name",
    taxId: "Tax ID",
    notifications: "Notifications",
    emailNotifications: "Email Notifications",
    emailNotificationsDesc: "Receive email updates about payments and contracts",
    paymentReminders: "Payment Reminders",
    paymentRemindersDesc: "Get notified about upcoming and overdue payments",
    contractAlerts: "Contract Alerts",
    contractAlertsDesc: "Notifications for contracts pending signature",
    display: "Display",
    darkMode: "Dark Mode",
    darkModeDesc: "Switch between light and dark themes",
    compactView: "Compact View",
    compactViewDesc: "Show more data with reduced spacing",
    security: "Security",
    twoFactorAuth: "Two-Factor Authentication",
    twoFactorDesc: "Add an extra layer of security to your account",
    changePassword: "Change Password",
    changePasswordDesc: "Update your account password",
    contactName: "Contact Name",
    contactPhone: "Contact Phone",
    companyAddress: "Company Address",
    currentPassword: "Current Password",
    newPassword: "New Password",
    passwordSaved: "Password updated successfully.",
    profileSaved: "Profile saved.",
    saveError: "Failed to save.",
  },

  // Import Dialog
  import: {
    title: "Import Units",
    uploadDesc: "Upload an Excel or CSV file to import units",
    mappingDesc: "Map file columns to unit fields",
    previewDesc: "Review the data before importing",
    resultDesc: "Import completed. Review summary and issues.",
    upload: "Upload",
    mapping: "Mapping",
    preview: "Preview",
    report: "Report",
    dropFile: "Drop your file here or click to browse",
    supportedFormats: "Supports Excel (.xlsx, .xls) and CSV files",
    selectFile: "Select File",
    columnMapping: "Column Mapping",
    rawFileSample: "Raw File Sample",
    sampleRows: "{count}-row sample",
    filePreview: "File Preview (first 10 rows)",
    mapRequired: "Map all required fields to continue.",
    selectColumn: "Select column",
    notMapped: "-- Not mapped --",
    backToMapping: "Back to Mapping",
    continueToPreview: "Continue to Preview",
    runImport: "Run Import",
    importing: "Importing...",
    importFailed: "Import failed",
    importFailedDesc: "Failed to import file. Please try again.",
    importFinished: "Import finished. Review summary and row-level issues.",
    importedCount: "Imported: {count}",
    skippedCount: "Skipped: {count}",
    errorCount: "Errors: {count}",
    totalCount: "Total: {count}",
    totalRows: "{count} total rows",
    validRows: "{count} valid",
    warningRows: "{count} warnings",
    erroredRows: "{count} errors",
    reportBuildings: "Buildings: new {new}, existing {existing}",
    reportLamellas: "Lamellas: new {new}, existing {existing}",
    reportFloors: "Floors: new {new}, existing {existing}",
    reportUnitTypes: "Unit types: new {new}, existing {existing}",
    reportUnits: "Units: new {new}, existing {existing}",
    issues: "Issues",
    noIssuesFound: "No issues found.",
    ok: "OK",
    row: "Row",
    severity: "Severity",
    severityError: "Error",
    severityWarning: "Warning",
    code: "Code",
    message: "Message",
    issueEmptyRow: "Row is empty.",
    issueMissingBuildingName: "Building name is required.",
    issueMissingLamella: "Lamella is required.",
    issueMissingUnitNumber: "Unit number is required.",
    issueMissingUnitType: "Unit type is required.",
    issueInvalidFloor: "Floor must be an integer value.",
    issueInvalidUnitValue: "Unit value must be a valid number.",
    issueInvalidArea: "Area must be a valid number.",
    issueDuplicateUnit: "Unit already exists and was skipped.",
    issueUnknown: "Unexpected import error.",
    buildingName: "Building Name",
    buildingAddress: "Building Address",
    unitType: "Unit Type",
    unitValue: "Unit Value",
    importUnits: "Import {count} Units",
    unitsToImport: "{count} units to import",
    importSuccessful: "Import successful",
    importSuccessDesc: "{count} units have been imported.",
    invalidFile: "Invalid file",
    invalidFileDesc: "File must contain at least a header row and one data row.",
    errorReading: "Error reading file",
    errorReadingDesc: "Could not parse the file. Please ensure it's a valid Excel or CSV file.",
    unitNumber: "Unit Number",
    lamella: "Lamella",
    floor: "Floor",
    areaSqm: "Area (m²)",
    price: "Price",
    type: "Type",
    status: "Status",
    noBuyersFound: "No buyers found",
    noUnitsFound: "No units found",
    searchBuyers: "Search buyers...",
    searchUnits: "Search by unit number or lamella...",
    buyersSelected: "buyer(s) selected",
    unitsSelected: "unit(s) selected",
  },

  // Forms
  forms: {
    // Building form
    buildingName: "Building Name",
    buildingNamePlaceholder: "e.g., Kula Avala",
    addressPlaceholder: "Full address including city and postal code",
    lamellasPlaceholder: "e.g., A, B, C",
    lamellasSeparatorHint: "Comma-separated list of lamella identifiers",
    selectStatus: "Select status",
    totalInvestment: "Total Investment ($)",
    totalInvestmentPlaceholder: "e.g., 45000000",
    buildingUpdated: "Building updated",
    buildingCreated: "Building created",
    buildingUpdateSuccess: "{name} has been updated successfully.",
    buildingCreateSuccess: "{name} has been created successfully.",
    newBuilding: "New Building",
    updateBuildingInfo: "Update building information",
    addNewBuildingProject: "Add a new building project",
    createBuilding: "Create Building",

    // Unit form
    unitNumberLabel: "Unit Number",
    unitNumberPlaceholder: "e.g., A101",
    typePlaceholder: "Select type",
    floorPlaceholder: "Floor number",
    areaPlaceholder: "e.g., 75.5",
    pricePlaceholder: "e.g., 250000",
    unitUpdated: "Unit updated",
    unitCreated: "Unit created",
    unitUpdateSuccess: "Unit {number} has been updated successfully.",
    unitCreateSuccess: "Unit {number} has been created successfully.",
    newUnit: "New Unit",
    updateUnitInfo: "Update unit information",
    addNewUnit: "Add a new unit to the building",
    createUnit: "Create Unit",

    // Buyer form
    fullNamePlaceholder: "e.g., Milos Jovanovic",
    emailPlaceholder: "e.g., milos.jovanovic@email.rs",
    phonePlaceholder: "e.g., +381 64 123 4567",
    idNumberLabel: "ID Number",
    idNumberPlaceholder: "e.g., 1205990712345",
    addressLabel: "Address",
    fullAddressPlaceholder: "Full address",
    notesOptional: "Notes (Optional)",
    notesPlaceholder: "Any additional notes about this buyer...",
    buyerUpdated: "Buyer updated",
    buyerCreated: "Buyer created",
    buyerUpdateSuccess: "{name} has been updated successfully.",
    buyerCreateSuccess: "{name} has been added successfully.",
    newBuyer: "New Buyer",
    updateBuyerInfo: "Update buyer information",
    addNewBuyer: "Add a new buyer to the system",

    // Contract form
    contractDate: "Date",
    paymentTypeFull: "Full Payment",
    paymentTypeInstallments: "Installments",
    paymentTypeCustom: "Custom Schedule",
    contractIsSigned: "Contract is signed",
    selectBuyer: "Please select at least one buyer",
    selectUnit: "Please select at least one unit",
    contractUpdated: "Contract updated",
    contractCreated: "Contract created",
    contractUpdateSuccess: "Contract #{number} has been updated successfully.",
    contractCreateSuccess: "Contract #{number} has been created successfully.",
    updateContractDetails: "Update contract details",
    createNewContract: "Create a new sales contract",
    createContract: "Create Contract",

    // Payment form
    recordPayment: "Record Payment",
    paymentAmount: "Payment Amount",
    paymentAmountPlaceholder: "e.g., 50000",
    paymentDate: "Payment Date",
    referenceLabel: "Reference / Transaction ID",
    referencePlaceholder: "e.g., TRX-001-2024",
    payFullRemaining: "Pay Full Remaining",
    paymentRecorded: "Payment recorded",
    paymentRecordedSuccess: "Payment of {amount} has been recorded.",
    amountError: "Amount must be greater than 0",
    totalValueLabel: "Total Value",
    paidSoFar: "Paid So Far",
    error: "Error",
    creditCard: "Credit Card",
  },

  // Payment methods
  paymentMethods: {
    bankTransfer: "Bank Transfer",
    check: "Check",
    cash: "Cash",
    creditCard: "Credit Card",
  },

  // Unit types
  unitTypes: {
    apartment: "Apartment",
    parking: "Parking",
    storage: "Storage",
    commercial: "Commercial",
    apt: "Apt",
    parkingSpot: "Parking Spot",
    storageUnit: "Storage Unit",
    commercialSpace: "Commercial Space",
  },

  // Unit statuses
  unitStatuses: {
    available: "Available",
    contracted: "Contracted",
    sold: "Sold",
  },

  // Floor labels
  floors: {
    basement: "Basement",
    ground: "Ground",
    floor: "Floor",
  },
};

export type Translations = typeof en;
